export const ApplicationStatusEnum = {
  KycInProgress: "KycInProgress",
  Pending: "Pending",
  Accepted: "Accepted",
  Rejected: "Rejected",
  Escalated: "Escalated",
  RedoKycInProgress: "RedoKycInProgress",
};
